/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2024, Zumper
 */

type Unit = {
  dateAvailablePassed: (now: number) => boolean
  dateAvailableDate: Date | undefined
  minPrice: number | null
}
export const sortByDateAndPrice = (now: number) => (unitA: Unit, unitB: Unit) => {
  const isUnitAAvailable = unitA.dateAvailablePassed(now) || unitA.dateAvailableDate == null
  const isUnitBAvailable = unitB.dateAvailablePassed(now) || unitB.dateAvailableDate == null
  const unitADateAvailable = unitA.dateAvailableDate
  const unitBDateAvailable = unitB.dateAvailableDate
  const hasAvailability = unitADateAvailable && unitBDateAvailable
  const isUnitACheaperThanUnitB =
    unitA.minPrice && unitB.minPrice && unitA.minPrice < unitB.minPrice
  const unitAandUnitBAvailable = isUnitAAvailable && isUnitBAvailable

  if (
    (unitAandUnitBAvailable && isUnitACheaperThanUnitB) ||
    (isUnitAAvailable && !isUnitBAvailable) ||
    (hasAvailability && unitADateAvailable < unitBDateAvailable) ||
    (hasAvailability && unitADateAvailable === unitBDateAvailable && isUnitACheaperThanUnitB)
  ) {
    return -1
  }
  if (
    (unitAandUnitBAvailable && !isUnitACheaperThanUnitB) ||
    (!isUnitAAvailable && isUnitBAvailable) ||
    (hasAvailability && unitADateAvailable > unitBDateAvailable) ||
    (hasAvailability && unitADateAvailable === unitBDateAvailable && !isUnitACheaperThanUnitB)
  ) {
    return 1
  }
  return 0
}
